﻿import { Component } from '@angular/core';
import { Tabla } from '../../tabla';

@Component({ template:  `
    <app-tabla [tabla]="tabla"></app-tabla>
` })
export class CategoriaDeporteUserComponent {

    tabla: Tabla = {
        titulo: 'Competencias',
        endPoint:'/rest-api/user/categoriaDeporte',
        nuevo: true,
        editable: true,
        columnas: [
            {
                name: 'ID',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 150
            },
            {
                name: 'Deporte',
                cell: 'nombre',
                prop: 'deporte',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 300
            },
            {
                name: 'Categoria',
                cell: 'nombre',
                prop: 'categoria',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 300
            }
        ]
    };

}
